import { render, staticRenderFns } from "./FileDragAndDrop.vue?vue&type=template&id=f5b01f5c&scoped=true"
import script from "./FileDragAndDrop.vue?vue&type=script&lang=js"
export * from "./FileDragAndDrop.vue?vue&type=script&lang=js"
import style0 from "./FileDragAndDrop.vue?vue&type=style&index=0&id=f5b01f5c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b01f5c",
  null
  
)

export default component.exports